// extracted by mini-css-extract-plugin
export default {"selectedQrIcon":"f8j0sisfCZEpeJ0Hd1xt"};